'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export const ReferenceCard = ({ reference }: { reference: Reference }) => {
  const { t } = useTranslations();

  return (
    <Link
      prefetch={false}
      href={ROUTES.REFERENCE({ slug: reference.slug })}
      className={cn(
        'group transition-all',
        'relative col-span-1 h-[215px] w-full overflow-hidden sm:h-[250px] lg:h-[275px] xl:h-[325px]',
      )}
    >
      <Image
        src={reference?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(reference?.image, reference?.name)}
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        sizes="(max-width: 639px) 100vw, (max-width: 767px) 100vw, (max-width: 1023px) 66vw, 50vw"
        className="absolute inset-0 z-0 h-full w-full"
      />
      <div
        className={cn(
          'transition-all group-hover:translate-y-0',
          'absolute inset-0 z-[1] flex h-full w-full translate-y-full items-center justify-center bg-primary/70',
        )}
      >
        <h2
          data-ea-visual-tag="h3"
          className="w-full text-center text-xl font-medium uppercase text-white md:text-2xl"
        >
          {reference.name}
        </h2>
        <Button
          variant={'secondary'}
          className="absolute bottom-4 left-1/2 -translate-x-1/2 translate-y-full group-hover:translate-y-0"
        >
          {t('text1377')}
        </Button>
      </div>
    </Link>
  );
};
